module.exports = __webpack_public_path__ + "00ab26937fd1d553a0cbfa2ec8e44c68.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/small/carolyn-stransky.jpg
// module id = 461
// module chunks = 0